// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectDetailsCertification_content__TF5IO","hrContent":"ProjectDetailsCertification_hrContent__hEPnb"};